export default function ({ app, store, redirect, route }) {
  if (!app.$auth.user || !app.$auth.user.tfa_authenticated) {
    app.$auth.$storage.setUniversal('tfa-redirect', route.fullPath);
    return redirect('/tfa');
  }
}
